module.exports = __webpack_public_path__ + "img/nepal.cc108ed.webp";